var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { useFindEntities } from './useFindEntities';
import { Entities } from '../const';
import { styled } from '@web/theme';
import { usePageEdit } from '../../ModulePage';
var isLinkExternal = function (url) { return url.toString().substr(0, 8).toLocaleLowerCase() === 'https://' || url.toString().substr(0, 7).toLocaleLowerCase() === 'http://'; };
export var useLinkEntities = function () {
    var showHelpers = usePageEdit().pageEdit.showHelpers;
    var LinkEntity = memo(function (_a) {
        var contentState = _a.contentState, entityKey = _a.entityKey, children = _a.children;
        var url = contentState.getEntity(entityKey).getData().url;
        return (isLinkExternal(url)
            ? React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer" }, children)
            : React.createElement(NavLink, { to: url }, children));
    });
    var PreventedLinkEntity = memo(function (_a) {
        var contentState = _a.contentState, entityKey = _a.entityKey, children = _a.children;
        var url = contentState.getEntity(entityKey).getData().url;
        var onClick = function (e) {
            e.preventDefault();
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("a", { href: url, target: "_blank", rel: "noopener noreferrer", onClick: onClick }, children),
            React.createElement(ExtLink, { visible: showHelpers && isLinkExternal(url) })));
    });
    var findLinkEntities = function (contentBlock, callback, contentState) {
        var findEntities = useFindEntities(Entities.LINK).findEntities;
        findEntities(contentBlock, callback, contentState);
    };
    return { LinkEntity: LinkEntity, PreventedLinkEntity: PreventedLinkEntity, findLinkEntities: findLinkEntities };
};
var ExtLink = memo(function (_a) {
    var visible = _a.visible;
    if (!visible)
        return null;
    return (React.createElement(ExtLabel, null, "[e]"));
});
var ExtLabel = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin-left: .2rem;\n\tpadding: 0 .2rem;\n\tbackground: black;\n\tcolor: white;\n\tfont-size: 12px;\n"], ["\n\tmargin-left: .2rem;\n\tpadding: 0 .2rem;\n\tbackground: black;\n\tcolor: white;\n\tfont-size: 12px;\n"])));
var templateObject_1;
